import ApiClient from '../ApiClient';
import { NiceResponse } from '../dto/NiceResponse';
import { AppUser } from '../../models/appUser';
import { AccessGrant, GrantWithDetails } from '../../models/accessGrant';
import { GrantAccessRequest } from './dto/GrantAccessRequest.dto';
import { UpdateGrantRequest } from './dto/UpdateGrantRequest.dto';

export class AccessGrantsApi {
  // eslint-disable-next-line no-unused-vars
  constructor(private api: ApiClient) {}

  // Поиск пользователей мобильного приложения (app_users) для админки.
  // GET /user/app-users?query=&skip=&take= (admin-auth), поиск по name/email,
  // ответ NiceResponse<AppUser[]> + total.
  async searchUsers(query: string, skip: number, take: number) {
    const params: { skip: number; take: number; query?: string } = {
      skip,
      take,
    };

    if (query && query !== '') {
      params.query = query;
    }

    const resp = await this.api.client.get<NiceResponse<AppUser[]>>(
      '/user/app-users',
      { params },
    );
    return resp.data;
  }

  // Выдать/перевыдать доступ к курсу (upsert по паре user_id+course_id).
  async grant(courseId: string, req: GrantAccessRequest) {
    const resp = await this.api.client.post<NiceResponse<AccessGrant>>(
      `/courses/${courseId}/access`,
      { ...req },
    );
    return resp.data;
  }

  // Список грантов пользователя (обогащённые: user_name/user_email/course_title).
  async listUserGrants(userId: string) {
    const resp = await this.api.client.get<NiceResponse<GrantWithDetails[]>>(
      `/courses/access?user_id=${userId}`,
    );
    return resp.data;
  }

  // Список грантов курса (кому выдан доступ; обогащённые).
  async listCourseGrants(courseId: string) {
    const resp = await this.api.client.get<NiceResponse<GrantWithDetails[]>>(
      `/courses/${courseId}/access`,
    );
    return resp.data;
  }

  // Изменить период/активность гранта. Отзыв доступа — is_active: false.
  async updateGrant(id: string, req: UpdateGrantRequest) {
    const resp = await this.api.client.put<NiceResponse<string>>(
      `/courses/access/${id}`,
      { ...req },
    );
    return resp.data;
  }

  // Удалить грант.
  async deleteGrant(id: string) {
    const resp = await this.api.client.delete<NiceResponse<string>>(
      `/courses/access/${id}`,
    );
    return resp.data;
  }
}
